module.exports = __webpack_public_path__ + "img/hyal-3.e813cd6f.png";